
export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8">
          {/* 회사 정보 */}
          <div className="md:col-span-2">
            <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              세계인재교육사
            </h3>
            <p className="text-gray-300 mb-4 leading-relaxed">
              한국 중고등학생을 위한 철학 교육 전문기관입니다.<br />
              매주 제공되는 철학 자료를 통해 학생들의 지혜와 리더십을 개발하고,<br />
              행복한 삶을 위한 올바른 가치관을 형성할 수 있도록 돕습니다.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-gray-700 rounded-full flex items-center justify-center hover:bg-gray-600 transition-colors cursor-pointer">
                <i className="ri-facebook-fill"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-700 rounded-full flex items-center justify-center hover:bg-gray-600 transition-colors cursor-pointer">
                <i className="ri-instagram-line"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-700 rounded-full flex items-center justify-center hover:bg-gray-600 transition-colors cursor-pointer">
                <i className="ri-youtube-line"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-700 rounded-full flex items-center justify-center hover:bg-gray-600 transition-colors cursor-pointer">
                <i className="ri-kakao-talk-fill"></i>
              </a>
            </div>
          </div>

          {/* 프로그램 안내 */}
          <div>
            <h4 className="text-lg font-semibold mb-4">프로그램</h4>
            <ul className="space-y-2 text-gray-300">
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">철학 기초 과정</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">리더십 개발</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">자기개발</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">솔로몬의 지혜</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">행복 찾기</a></li>
            </ul>
          </div>

          {/* 고객 지원 */}
          <div>
            <h4 className="text-lg font-semibold mb-4">고객 지원</h4>
            <ul className="space-y-2 text-gray-300">
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">자주 묻는 질문</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">이용 가이드</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">회원 혜택</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">환불 정책</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">개인정보처리방침</a></li>
            </ul>
          </div>
        </div>

        {/* 하단 정보 */}
        <div className="border-t border-gray-700 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 text-sm mb-4 md:mb-0">
              <p>© 2024 세계인재교육사. All rights reserved.</p>
              <p className="mt-1">사업자등록번호: 123-45-67890 | 대표: 홍길동 | 주소: 서울특별시 강남구 테헤란로 123</p>
            </div>
            <div className="text-gray-400 text-sm">
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:text-white transition-colors cursor-pointer"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
